import React, { useEffect } from "react";
import { usePaginatedProducts } from "../utils/hooks/usePaginatedProducts.ts";
import { Schema } from "../utils";
import { useCore } from "../hooks";
import { ProductListRow } from "./ProductListRow.tsx";
import { useIntersect } from "../utils/hooks/useIntersect.ts";
import { Loader } from "./Loader.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ProductList: React.FC = () => {
  const { searchString, searchType, selectedCheckoutId, checkouts } = useCore()
  const { measureRef, isIntersecting } = useIntersect()
  const filterDepotsIds = checkouts.find(c => c.id === selectedCheckoutId)?.depots?.map(d => d.id)

  const { refresh, products, loading, loadMore, isLastPage, totalCount } = usePaginatedProducts({
    filters: {
      listType: 'children_and_parents_without_children',
      enabled: true,
      fulltext: searchString,
      availability: searchType,
      depots: searchType !== 'all' ? filterDepotsIds : [],
    },
    sort: 'name',
    direction: 'ASC',
    schema: Schema.product.detail,
  })

  useEffect(() => {
    if (isIntersecting) {
      loadMore()
    }
  }, [isIntersecting])

  if (!products?.length) {
    return loading ? <Loader size={'half'} /> : <div className="w-1/2 h-body-without-header scrollable-y">
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-xl font-bold flex flex-col items-center gap-x-2 text-center text-[#F0929C]">
          <FontAwesomeIcon icon={['far', 'face-thinking']} size="2x" className="mb-2" />
          <span>Nic nenalezeno,<br/> zkuste hledání opakovat.</span>
        </div>
      </div>
    </div>
  }
  return (
    <div className="w-1/2 h-body-without-header scrollable-y px-2 2xl:px-6 pr-2 py-2">
      {products.map((prod, i) => <ProductListRow product={prod} key={`product-${prod.id}-${i}`} />)}
      {!isLastPage && (
        <div ref={measureRef}>next page..</div>
      )}
    </div>
  );
}
